// Search hooks for the paginated list endpoints (locations_search.rs,
// screens_search.rs). The request object is the query key, so a changed
// filter is a new query — and `placeholderData` holds the previous page's
// rows during the refetch, or every keystroke flashes the table's skeleton.

import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { http } from "./http";
import { searchKeys } from "./keys";
import type {
    LocationFilters,
    LocationListEntry,
    LocationQueryField,
    LocationSortField,
    PageRs,
    ScreenFilters,
    ScreenSearchEntry,
    ScreenSearchQueryField,
    ScreenSortField,
    SearchRq,
} from "./types";

export function useLocationsSearch(
    workspaceId: string,
    rq: SearchRq<LocationFilters, LocationSortField, LocationQueryField>,
) {
    return useQuery({
        queryKey: searchKeys.locations(workspaceId, rq),
        queryFn: () =>
            http.post<PageRs<LocationListEntry>>(`/v1/workspaces/${workspaceId}/locations/search`, { json: rq }),
        enabled: Boolean(workspaceId),
        placeholderData: keepPreviousData,
    });
}

export function useScreensSearch(
    workspaceId: string,
    rq: SearchRq<ScreenFilters, ScreenSortField, ScreenSearchQueryField>,
) {
    return useQuery({
        queryKey: searchKeys.screens(workspaceId, rq),
        queryFn: () =>
            http.post<PageRs<ScreenSearchEntry>>(`/v1/workspaces/${workspaceId}/screens/search`, { json: rq }),
        enabled: Boolean(workspaceId),
        placeholderData: keepPreviousData,
    });
}
